<template>
  <i18n-t keypath="NotificationsComponent.backupOverdueNotificationFrequencySuccess" tag="div" scope="global">
    <template #computer>
      <strong>{{ props.notification?.params?.deviceName ?? "" }}</strong>
    </template>
  </i18n-t>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import { INotification } from "@/stores/notificationsInterfaces";

const props = defineProps({
  notification: {
    type: Object as PropType<INotification>,
    required: true,
  },
});
</script>
